import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';


import { validateProsentValue } from '../utils';
import Warning from './WarningComponent';
import validator from 'validator';

import { getUIText } from '../utils/index';

const checkWarnings = (min, max, value, ) => {
  if(min != undefined && Number(value) < Number(min)) {
    return {warning: true, warningText: 'GENERAL-MINIMUM_VALUE', value: min, showValue: true};
  } else  if(max != undefined && Number(value) > Number(max)) {
    return {warning: true, warningText: 'GENERAL-MAXIMUM_VALUE', value: max, showValue: true};
  } else {
    return {warning: true, warningText: 'GENERAL-NOT_VALID_VALUE', value, showValue: false};
  }
};

class InputComponent extends Component {

  constructor(props) {
    super(props);

    const result = this.checkValues(this.props);
    if(!result) {
      this.state = {
        value: '',
        previousValidValue: null,
        warning: false,
        warningText: ''
      };
    } else {
      this.state = {
        value: '',
        previousValidValue: null,
        warning: result.warning,
        warningText: result.warningText
      };
    }
  }

  handleChange = event => {
    if(!this.props) return;
    const {unit, min, max, warningText, type, app, translations} = this.props;

    if(type === 'string') {
      this.setState({warning: false, previousValidValue: event.target.value});
      if (this.props.onChange) {
        this.props.onChange(event.target.value);
      }
      return;
    }

    let options = {};
    if(min != undefined) {
      options.min = Number(min);
    }

    if(max != undefined) {
      options.max = Number(max);
    }

    if(!validator.isInt(event.target.value, {...options, allow_leading_zeroes: false}) && !validator.isFloat(event.target.value, options)) {
      const {warning, warningText, value, showValue } = checkWarnings(min, max, event.target.value);

      if (warning) {
        this.setState({warning: true, warningText: getUIText(warningText, app.language, translations) + (showValue ? ' ' + value : ''), value});
      }
      // if(min != undefined && Number(event.target.value) < Number(min)){
      //   this.setState({warning: true, warningText: getUIText("GENERAL-MINIMUM_VALUE", app.language, translations) + min, value:event.target.value})
      // } else  if(max != undefined && Number(event.target.value) > Number(max)){
      //   this.setState({warning: true, warningText: getUIText("GENERAL-MAXIMUM_VALUE", app.language, translations) + max, value:event.target.value})
      // } else {
      //   this.setState({warning: true, warningText: getUIText("GENERAL-NOT_VALID_VALUE", app.language, translations), value:event.target.value})
      // }
      return;
    }

    if(unit === '%' && !validateProsentValue(Number(event.target.value))) {
      event.preventDefault();
      return;
    }

    let returnValue = event.target.value;
    if(unit === 'm/s' ) {
      // if(returnValue > 0 && returnValue < 0.5){
      //   returnValue = 0
      // }
    }

    this.setState({warning: false, value: null, previousValidValue: returnValue});
    if (this.props.onChange) {
      this.props.onChange(returnValue);
    }
  }

  handleOnKeyPress = event => {
    const {unit, type, min, max} = this.props;
    const charCode = event.keyCode || event.which;

    // Mobile enter click
    if(charCode === 13) {
      document.activeElement.blur();
      event.preventDefault();
      return;
    }
  }

  onClick = event => {
    if (this.input) {
      this.input.focus();
    }
  }

  refFunc = target => {
    this.input = target;
  }

  onBlurHandler = target => {
    if(!this.props) return;
    if(this.state.warning) {
      if (this.props.onChange && this.state.previousValidValue != undefined) {
        this.setState({warning: false, value: null});
        this.props.onChange(this.state.previousValidValue);
      }
    }
  }

  checkValues = (props) =>{
    const {value, label, unit, type, className, max, min, disabled, unitType, thicknessAlert, translations, app} = this.props;

    if(type === 'string') {
      return false;
    }

    let options = {};
    if(min != undefined) {
      options.min = Number(min);
    }

    if(max != undefined) {
      options.max = Number(max);
    }
    if(!validator.isInt(value.toString(), {...options, allow_leading_zeroes: false}) && !validator.isFloat(value.toString(), options)) {
      const {warning, warningText, value, showValue } = checkWarnings(min, max, value);

      if(warning) {
        return ({warning: true, warningText: getUIText(warningText, app.language, translations) + (showValue ? ' ' + value : ''), value });
      }
      return false;
    }
  }

  render() {
    const {value, label, unit, type, className, min, max, disabled, unitType, thicknessAlert, translations, app} = this.props;

    const result = this.checkValues(this.props);

    let inputValue = value;
    if( inputValue === undefined || inputValue === null ) {
      inputValue = '';
    }

    // checkWarnings
    let stepSize = 1;
    if(unit === 'm/s') {
      // if(parseFloat(value) < 0.5){
      //   stepSize = 0.5
      // } else {
        stepSize = 0.1;
      // }
    }
    return (
      <div className={className ? 'input-component ' + className : 'input-component '} >
        <div className="item-container" onClick={this.onClick.bind(this)}>
          {label ? <label className="label" >{label}</label> : null}
          <div>
            <Input
              value={this.state.warning ? this.state.value : inputValue}
              fullWidth
              inputRef={this.refFunc.bind(this)}
              classes={{disabled: 'input-disabled'}}
              className="input-item"
              disabled={disabled ? disabled : false}
              inputProps={type == 'string' ? {} : {type: 'number', pattern: '\d*', step: stepSize}}
              onChange={this.handleChange}
              onKeyPress={this.handleOnKeyPress}
              onBlur={this.onBlurHandler.bind(this)} />
            {unit ?
               disabled ?
                 <span className="unit" style={{color: '#BDBDBD'}}>{unit}</span> :
                 <span className="unit">{unit}</span>
              : null}
            {this.state.warning
              ? <Warning visible={this.state.warning} info={this.state.warningText}/>
              : (
                result &&
                  <Warning visible={result.warning} info={getUIText(result.warningText, app.language, translations) + (result.showValue ? ' ' + result.value : '')} />
              )
            }
            {(translations && app) ? <Warning visible={thicknessAlert} info={getUIText('OBJECT-THICKNESS_ALERT', app.language, translations)}/> : null}
          </div>
        </div>
      </div>
    );
  }
}

InputComponent.propTypes = {
    label: PropTypes.string,
  unit: PropTypes.any,
  min: PropTypes.any,
  max: PropTypes.any,
  warningText: PropTypes.any,
  type: PropTypes.any,
  app: PropTypes.any,
  translations: PropTypes.any,
  onChange: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.any,
  disabled: PropTypes.any,
  unitType: PropTypes.any,
  thicknessAlert: PropTypes.any,
};

export default InputComponent;
